import {
  ProjcetNotesWrapper,
  NotesList,
  NoteItem,
  AddNoteWrapper,
  AddNoteInput,
  AddNoteBtn,
  NoteItemWrapper,
  RemoveItemBtn,
} from './styles';

import useForm from '../../hooks/useForm';
import ValidationInput from '../ValidationInput';

const ProjectNotesEdit = ({ notes, setEditedDataField }) => {
  const { formValues, handleChange, setValues } = useForm({
    initialValues: {
      addNoteInput: '',
    },
  });

  const addNote = () => {
    if (formValues.addNoteInput.length <= 0 || formValues.addNoteInput.length > 1020) {
      return;
    }
    let currentData = [...notes];
    currentData.push(formValues.addNoteInput);
    setEditedDataField('resNotes', currentData);
    setValues({ addNoteInput: '' });
  };

  return (
    <ProjcetNotesWrapper>
      <NotesList>
        {notes.map((note, index) => (
          <NoteItemWrapper key={index}>
            <NoteItem key={index}>{note}</NoteItem>
            <RemoveItemBtn
              onClick={() => {
                let modifiedData = [...notes];
                modifiedData.splice(index, 1);
                setEditedDataField('resNotes', modifiedData);
              }}
            />
          </NoteItemWrapper>
        ))}
      </NotesList>
      <AddNoteWrapper>
        <ValidationInput
          component={AddNoteInput}
          containerStyle={{ width: '100%', height: '200px' }}
          placeholder='Note...'
          value={formValues.addNoteInput}
          onChange={handleChange}
          name='addNoteInput'
          validation={(value) => value.length < 1021}
          errorMsg={'Note is too long, max characters allowed: 1020'}
          type='text'
        />
        <AddNoteBtn
          title={'add note'}
          onClick={addNote}
          disabled={formValues.addNoteInput.length > 1020}
        />
      </AddNoteWrapper>
    </ProjcetNotesWrapper>
  );
};

export default ProjectNotesEdit;
